import create from 'zustand';

interface ToggleStore {
  isToggled: boolean;
  toggle: () => void;
  setToggle: (value: boolean) => void;
}

const useToggleStore = create<ToggleStore>((set) => ({
  isToggled: false,
  toggle: () => set((state) => ({ isToggled: !state.isToggled })),
  setToggle: (value) => set({ isToggled: value }),
}));

export default useToggleStore;
